import createLucideIcon from '../createLucideIcon';

const ArrowDownToDot = createLucideIcon('ArrowDownToDot', [
  ['line', { x1: '12', x2: '12', y1: '2', y2: '16', key: '1kkguj' }],
  ['polyline', { points: '19,9 12,16 5,9', key: '15pyxh' }],
  ['circle', { cx: '12', cy: '21', r: '1', key: 'o0uj5v' }],
]);

export default ArrowDownToDot;
